// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1xBdk","paramInput":"JobSimulator_paramInput__1MrgC","input":"JobSimulator_input__2bvyw"};